import { render } from "./IconPeople.vue?vue&type=template&id=d28401ce"
import script from "./IconPeople.vue?vue&type=script&lang=js"
export * from "./IconPeople.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\suph-annuaire-plugin\\suph-card-pro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__